import * as FileSaver from 'file-saver';
import { Router } from '@angular/router';
import { ConfirmationService, Message } from 'primeng/primeng';
import { AgentService } from './../../../services/agent.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-chargement-objectif',
  templateUrl: './chargement-objectif.component.html',
  styleUrls: ['./chargement-objectif.component.css']
})
export class ChargementObjectifComponent implements OnInit {
  dateValue: Date;
  uploadedFile: File;
  displaychargement = false;
  msgs: Message[] = [];
  colorFieldset = 'primary';
  colorPanel = 'primary';
  produit: any;
  typeObjectif: any;
  loadResponse: any = new Object();
  listProduit: any[] = [
    {
      value: '',
      label: '--PRODUIT--'
    },
    {
      value: 'NAFAMA',
      label: 'NAFAMA'
    },
    {
      value: 'ORANGE_MONEY',
      label: 'ORANGE_MONEY'
    },
    {
      value: 'DUAL_WALLET',
      label: 'DUAL_WALLET'
    }
  ];
  listTypeObjectif: any[] = [
    {
      value: '',
      label: '--TYPE OBJECTIF--'
    },
    {
      value: 'COMMANDE',
      label: 'COMMANDE'
    },
    {
      value: 'VENTE',
      label: 'VENTE'
    },
    {
      value: 'CASHOUT',
      label: 'CASHOUT'
    }
  ];

  constructor(
    private agentService: AgentService,
    private confirmationService: ConfirmationService, private route: Router) {
  }

  ngOnInit() {
  }
  async charger() {
    console.log('this.produit', this.produit);
    console.log('this.typeObjectif', this.typeObjectif);

    if (!this.uploadedFile) {
      this.msgs = []; this.msgs.push({ severity: 'error', summary: 'erreur', detail: 'Merci de choisir un fichier' });
      return;
    } else if (!this.dateValue) {
      this.msgs = []; this.msgs.push({ severity: 'error', summary: 'erreur', detail: 'Merci de choisir une période' });
      return;
    } else if (!this.produit) {
      this.msgs = []; this.msgs.push({ severity: 'error', summary: 'erreur', detail: 'Merci de choisir un produit' });
      return;
    } else if (!this.typeObjectif) {
      this.msgs = []; this.msgs.push({ severity: 'error', summary: 'erreur', detail: 'Merci de choisir un type d\'objectif' });
      return;
    } else if ((this.produit === 'ORANGE_MONEY' && (this.typeObjectif === 'VENTE' || this.typeObjectif === 'COMMANDE')) || (this.produit === 'NAFAMA' && this.typeObjectif === 'CASHOUT' )) {
      this.msgs = []; this.msgs.push({ severity: 'error', summary: 'erreur', detail: 'Le type selectionné ne correspond pas au produit' });
      return;
    } else {
      this.displaychargement = true;
      const formData = new FormData();
      formData.append('file', this.uploadedFile);
      formData.append('periode', this.dateValue.toLocaleDateString());
      formData.append('produit', this.produit);
      formData.append('typeObjectif', this.typeObjectif);
      console.log('formData: ', formData);
      try {
        this.loadResponse = (await this.load(formData) as any);
        this.msgs = []; this.msgs.push({ severity: 'info', summary: 'Confirmation', detail: 'Vérification effectuée avec succès' });
      } catch (error) {
        this.msgs = []; this.msgs.push({ severity: 'warring', summary: 'Confirmation', detail: 'Vérification échouée' });
      } finally {
        this.displaychargement = false;
      }

      console.log('loadResponse: ', this.loadResponse);
    }
  }

  async load(formData: any) {
    return await this.agentService.chargerObjectif(formData).toPromise();
  }

  refaire() {
    window.location.reload();
  }


  exportCharges() {
  }

  async doSend() {
    this.displaychargement = true;
    try {
      await this.send();
      this.msgs = []; this.msgs.push({ severity: 'info', summary: 'Confirmation', detail: 'Chargement effectuée avec succès' });
      setTimeout(() => {
        console.log('waiting');
        this.route.navigateByUrl('/root/modification-objectif');
      }, 100);
    } catch (error) {
      this.msgs = []; this.msgs.push({ severity: 'warring', summary: 'Confirmation', detail: 'Chargement échoué' });
    } finally {
      this.displaychargement = false;
    }
  }

  async send() {
    return await this.agentService.send().toPromise();
  }

  detectFiles0(event) {
    this.uploadedFile = event.target.files[0];
    console.log('files: ', this.uploadedFile);
  }

  exportFormat() {
    const data = [{ distributeur: 'distX', sous_zone: 'sous_zX', objectif: 'objX' },
    { distributeur: 'distY', sous_zone: 'sous_zY', objectif: 'objY' },
    { distributeur: 'distZ', sous_zone: 'sous_zZ', objectif: 'objZ' }];
    const replacer = (key, value) => value === null ? '' : value; // specify how you want to handle null values here
    const header = Object.keys(data[0]);
    let csv = data.map(row => header.map(fieldName => row[fieldName], replacer).join(';'));
    csv.unshift(header.join(';'));
    let csvArray = csv.join('\r\n');
    var blob = new Blob([csvArray], { type: 'text/csv' });
    FileSaver.saveAs(blob, 'FORMAT_OBJECTIF.csv');
  }

  exportErreurs() {
    const data = this.loadResponse.erreurs;
    const replacer = (key, value) => value === null ? '' : value; // specify how you want to handle null values here
    const header = Object.keys(data[0]);
    let csv = data.map(row => header.map(fieldName => row[fieldName], replacer).join(';'));
    csv.unshift(header.join(';'));
    let csvArray = csv.join('\r\n');
    var blob = new Blob([csvArray], { type: 'text/csv' });
    FileSaver.saveAs(blob, 'ERREUR_CHARGEMENT_OBJECTIF.csv');
  }

  exportSendResponse() {
  }

}
